<!-- 数値入力フィールドコンポーネント -->
<template>
  <Field
    :name="name"
    :label="label"
    :model-value="modelValue"
    :rules="rules"
    v-slot="{ field, errorMessage }"
  >
    <input
      :name="field.name"
      :data-testid="field.name"
      type="text"
      pattern="-?[0-9]*\.?[0-9]*"
      :class="['input-text', 'num', inputClass, { 'is-error': !!errorMessage || !!externalError }]"
      :value="displayValue(field.value)"
      @focus="onFocus"
      @input="(e) => onInputRaw(e, field)"
      @blur="(e) => onBlur(field, e as FocusEvent)"
      :inputmode="inputmode"
      autocomplete="off"
    />
  </Field>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate'
import { ref } from 'vue'

const props = defineProps({
  name: { type: String, required: true },
  label: { type: String, default: undefined },
  modelValue: { type: [String, Number, null], default: '' },
  decimals: { type: Number, default: 1 },
  rules: { type: [String, Object], default: '' },
  inputClass: { type: [String, Array, Object], default: '' },
  externalError: { type: [String, Boolean], default: '' },
  inputmode: {
    type: String as () => 'decimal' | 'text',
    default: 'decimal',
  },
})

const emit = defineEmits(['update:modelValue', 'blur'])

const isFocused = ref(false)

const displayValue = (fieldValue: unknown) => {
  const val = fieldValue ?? props.modelValue
  return String(val ?? '')
}

const INPUT_REGEX = /^-?\d*\.?\d*$/
function onInputRaw(e: Event, field: any) {
  const el = e.target as HTMLInputElement
  const v = el.value

  if (!INPUT_REGEX.test(v)) {
    el.value = displayValue(field.value)
    return
  }

  if (props.decimals === 0 && v.includes('.')) {
    el.value = displayValue(field.value)
    return
  }
  
  const newValue = v === '' ? null : v
  field.onChange?.(newValue)
  emit('update:modelValue', newValue)
}

function onFocus(e: FocusEvent) {
  isFocused.value = true
}

function onBlur(field: any, e: FocusEvent) {
  isFocused.value = false
  field.onBlur?.(e)
  emit('blur')
}
</script>
